import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { MSP_NOTIFICATIONS } from 'containers/Settings/Notifications/EndUser/constants'

class AnnouncementList extends React.Component {
  static propTypes = {
    items: PropTypes.array,
  }

  componentDidMount() {
    if (this.props.items.length) {
      this.props.selectAnnouncement(0)
    }
  }

  handleSelection = (itemIndex) => {
    this.props.selectAnnouncement(itemIndex)
  }

  render() {
    const { items, activeIndex, languages } = this.props
    const mapLanguages = {}
    if (languages) {
      for (let i = 0; i < languages.length; i++) {
        mapLanguages[languages[i].value] = languages[i].label
      }
    }

    return (
      <React.Fragment>
        {items.map((item, i) => (
          <AnnouncementListItem
            key={item.id}
            selected={i === activeIndex}
            onClick={this.handleSelection.bind(this, i)}
          >
            <div className="announcementList-item-title">
              {item.name}
              {MSP_NOTIFICATIONS.includes(item.trigger) && <MSPIndicator>MSP</MSPIndicator>}
            </div>
            <div className="announcementList-item-description">{item.description}</div>
            <GrayedOut title="Count of languages" className="dots announcementList-item-count">
              <LanguageIndicator>{item.locales.length}</LanguageIndicator>
            </GrayedOut>
          </AnnouncementListItem>
        ))}
      </React.Fragment>
    )
  }
}

const GrayedOut = styled.span`
  color: ${(props) => props.theme.textGray};
`

const AnnouncementListItem = styled.div`
  padding: 10px 10px 10px 25px;
  position: relative;
  border-bottom: solid 1px #e5e5e5;
  cursor: pointer;
  ${(props) =>
    props.selected &&
    `
    background: #F7FAFF

    &::after {
      content: ' ';
      position: absolute;
      width: 8px;
      background-color: #00AFFF;
      left: 0;
      top: 0;
      bottom: 0;
    }
  `}
  .announcementList-item-title {
    color: ${(props) => props.theme.primaryColor};
    width: calc(100% - 50px);
    margin-bottom: 10px;
    font-weight: bold;
  }
`

const LanguageIndicator = styled.div`
  color: #ffffff;
  font-size: 10px;
  text-align: center;
  line-height: 1;
  padding: 2px 10px;
  position: absolute;
  top: 12px;
  right: 5px;
  border-radius: 7px;
  background: #f83a32;
`

const MSPIndicator = styled.span`
  color: #00aff0;
  font-size: 10px;
  text-align: center;
  line-height: 1;
  padding: 1px 2px;
  position: relative;
  background: #bcfbff;
  margin-left: 4px;
`

export default AnnouncementList
